import React from 'react';
import { Card, CardContent } from './ui/card';

export default function KpiCard({ label, value, icon: Icon, sublabel, intent = 'default', testid = 'kpi-card' }) {
  const intentClasses = {
    success: 'text-[hsl(var(--success))]',
    danger: 'text-[hsl(var(--danger))]',
    default: 'text-foreground',
  }[intent];

  return (
    <Card className="rounded-xl border-border/70 bg-card" data-testid={testid}>
      <CardContent className="p-5">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0 flex-1">
            <div className="text-xs font-medium text-muted-foreground uppercase tracking-wide">{label}</div>
            <div className={`mt-2 text-xl sm:text-2xl font-semibold tracking-tight tabular break-words ${intentClasses}`} data-testid={`${testid}-value`}>
              {value}
            </div>
            {sublabel && <div className="mt-1 text-xs text-muted-foreground">{sublabel}</div>}
          </div>
          {Icon && (
            <div className="h-10 w-10 shrink-0 rounded-lg bg-muted/70 grid place-items-center text-foreground/70">
              <Icon className="h-5 w-5" />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
